export interface ModuleDefinition {
  type: number;
  routeSegment: string;
  moduleFolder: string;
  translationKey: string;
  showInMainHeader: boolean;
  showInMobileSelector: boolean;
}

export const MODULE_DEFINITIONS: Record<number, ModuleDefinition> = {
  1: { type: 1, routeSegment: 'traffic', moduleFolder: 'traffic', translationKey: 'Trafico', showInMainHeader: true, showInMobileSelector: true },
  2: { type: 2, routeSegment: 'management', moduleFolder: 'management', translationKey: 'Gestion', showInMainHeader: true, showInMobileSelector: true },
  3: { type: 3, routeSegment: 'admin', moduleFolder: 'administrate', translationKey: 'Administrar', showInMainHeader: false, showInMobileSelector: true },
  4: { type: 4, routeSegment: 'telemetry', moduleFolder: 'telemetry', translationKey: 'Telemetría', showInMainHeader: true, showInMobileSelector: true },
  6: { type: 6, routeSegment: 'weather', moduleFolder: 'weather', translationKey: 'Clima', showInMainHeader: true, showInMobileSelector: true },
  8: { type: 8, routeSegment: 'developer', moduleFolder: 'developer', translationKey: 'Developer', showInMainHeader: false, showInMobileSelector: false },
  9: { type: 9, routeSegment: 'zar', moduleFolder: 'zar', translationKey: 'infracciones', showInMainHeader: true, showInMobileSelector: true },
  10: { type: 10, routeSegment: 'red-light', moduleFolder: 'red-light', translationKey: 'foto-rojo', showInMainHeader: true, showInMobileSelector: true },
  11: { type: 11, routeSegment: 'waste', moduleFolder: 'waste', translationKey: 'Residuos', showInMainHeader: true, showInMobileSelector: false },
  12: { type: 12, routeSegment: 'crosswalk', moduleFolder: 'crosswalk', translationKey: 'paso-cebra', showInMainHeader: true, showInMobileSelector: false },
  103: { type: 103, routeSegment: 'help', moduleFolder: 'help', translationKey: 'ayuda', showInMainHeader: true, showInMobileSelector: false },
};

export const MODULE_TYPE_TO_ROUTER_LINK: Record<number, string> = {};
export const ROUTER_LINK_TO_MODULE_TYPE: Record<string, number> = {};

Object.values(MODULE_DEFINITIONS).forEach((def) => {
  MODULE_TYPE_TO_ROUTER_LINK[def.type] = def.routeSegment;
  ROUTER_LINK_TO_MODULE_TYPE[def.routeSegment] = def.type;
});

ROUTER_LINK_TO_MODULE_TYPE['infractions'] = 9;
